module.exports = __webpack_public_path__ + "6ed28012d7fcadc4218a7a14cf041995.svg";